import React from 'react';
import marked from 'marked';

import { renderWhenTrue } from '../../utils';

import { ChildrenContainer, Container, ContentSection, OKSection } from './alertPopup.styled';
import { AlertPopupData } from './alertPopup.types';

export const AlertPopup: React.FC<AlertPopupData> = (data: AlertPopupData) => {
  const {
    content,
    isAlertVisible,
    closeAction = Function.prototype,
    backgroundColor,
    hideOKButton,
    buttonLabelColor,
    children,
  } = data;

  const closeAlert = (): void => {
    closeAction();
  };

  const renderContentSection = renderWhenTrue(() => (
    <ContentSection
      dangerouslySetInnerHTML={{__html: marked(content)}}
    />
  ));

  const renderOKSection = renderWhenTrue(() => (
    <OKSection
      onClick={closeAlert}
      textColor={buttonLabelColor}
    >
      OK
    </OKSection>
  ));

  const renderChildren = renderWhenTrue(() => (
    <ChildrenContainer>
      {children}
    </ChildrenContainer>
  ));

  return (
    <Container
      isVisible={isAlertVisible}
      backgroundColor={backgroundColor}
    >
      {renderChildren(!!children)}
      {renderContentSection(!!content)}
      {renderOKSection(!hideOKButton)}
    </Container>
  );
}
